import { Injectable, inject } from '@angular/core';
import { ApiService } from './api.service';
import { ItemAnalystGroup } from 'portal-shared';

@Injectable({
  providedIn: 'root',
})
export class AnalystGroupsService {
  private readonly apiService = inject(ApiService);

  async getAnalystGroups(): Promise<ItemAnalystGroup[]> {
    const response = await this.apiService.get<ItemAnalystGroup[] | undefined>(
      '/ari/analyst-groups',
    );
    return response ?? [];
  }

  async searchAnalystGroups(searchTerm: string): Promise<ItemAnalystGroup[]> {
    if (!searchTerm || searchTerm.trim().length < 2) {
      return [];
    }

    const encodedSearch = encodeURIComponent(searchTerm.trim());
    const response = await this.apiService.get<ItemAnalystGroup[] | undefined>(
      `/ari/analyst-groups/search?search=${encodedSearch}`,
    );
    return response ?? [];
  }

  async getAnalystIdsByGroupId(groupId: number): Promise<number[]> {
    const response = await this.apiService.get<number[] | undefined>(
      `/ari/influencers/analyst-groups/${groupId}/analysts`,
    );
    return response ?? [];
  }
}
